var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Right_Icon",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  id: "Right_Icon_Background",
  cx: 6,
  cy: 6,
  r: 6,
  fill: "#2bc822"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Right_Icon_Tick",
  d: "M263.718,580.943l-.173-.18a.477.477,0,0,0-.692,0l-2.941,3.061-1.044-1.085a.476.476,0,0,0-.692,0l-.173.18a.526.526,0,0,0,0,.72l1.561,1.627a.478.478,0,0,0,.692,0l3.461-3.6a.527.527,0,0,0,0-.72Z",
  transform: "translate(-254.86 -576.814)",
  fill: "#fff"
})));
export default __webpack_public_path__ + "static/media/right_check.964e201f.svg";
export { SvgComponent as ReactComponent };